import React, { PureComponent } from 'react';
import BoltIcon from 'components/icons/BoltIcon';
import locationTextPretty from 'modules/homescreen/helpers/locationTextPretty';
import { Translator } from 'Translator';
import MarkerIcon from 'components/icons/MarkerIcon';
import NewLabel from './NewLabel';

const CSS = require('./SuggestionsListItem.less');

const ENTER_KEY = 13;
const DOWN_ARROW_KEY = 40;
const UP_ARROW_KEY = 38;

type SuggestionsListItemProps = {
  city: string;
  country: string;
  place: string;
  distanceTo: number;
  inFocus: boolean;
  isComingSoon?: boolean;
  onSelect: (suggestion: { city: string; country: string; place: string }, lockIn?: boolean) => void;
  listIndex: number;
  focusNextSuggestion: (listIndex: number) => { city: string; country: string };
  focusPreviousSuggestion: (listIndex: number) => { city: string; country: string };
  suggestionType: 'suggestions' | 'popularlocations' | 'recentsearches' | 'other' | 'nearbydestinations';
  isNew: boolean;
};

class SuggestionsListItem extends PureComponent<SuggestionsListItemProps> {

  ref: HTMLLIElement;

  onClick = () => {
    this.props.onSelect({ city: this.props.city, country: this.props.country, place: this.props.place }, true);
  };

  onKeyDown = (e: any) => {
    if (e.keyCode === ENTER_KEY) {
      this.props.onSelect({ city: this.props.city, country: this.props.country, place: this.props.place }, true);
    }

    if (e.keyCode === DOWN_ARROW_KEY) {
      e.preventDefault();
      this.props.focusNextSuggestion(this.props.listIndex);
    } else if (e.keyCode === UP_ARROW_KEY) {
      e.preventDefault();
      this.props.focusPreviousSuggestion(this.props.listIndex);
    }
  };

  componentDidUpdate(prevProps) {
    if (!prevProps.inFocus && this.props.inFocus) {
      this.ref.focus();
    }
  }

  getSuggestionIcon = () => {
    switch (this.props.suggestionType) {
      case 'popularlocations':
      case 'suggestions':
      case 'nearbydestinations':
        return <MarkerIcon className={CSS.Icon} width={9} height={12} />;
      case 'recentsearches':
        return <BoltIcon className={CSS.Icon} width={9} height={12} />;
      default:
        return null;
    }
  };

  setRef = c => this.ref = c;

  render() {
    const { city, country, place, distanceTo, isComingSoon, isNew } = this.props;

    return (
      <li
        ref={this.setRef}
        tabIndex={0}
        className={CSS.ListItem}
        onClick={this.onClick}
        onKeyDown={this.onKeyDown}
      >
        <div className={CSS.IconContainer}>
          {this.getSuggestionIcon()}
        </div>
        {locationTextPretty(city, country, place)}
        {
          distanceTo &&
          <span className={CSS.Distance}>{Math.ceil(distanceTo / 1000)}km</span>
        }
        {isComingSoon && <span className={CSS.ComingSoon}>{Translator.translate('Common.ComingSoon', {}, true, 'Coming Soon')}</span>}
        {isNew && <NewLabel />}
      </li>
    );
  }
}

export default SuggestionsListItem;
